import React, { Component } from "react";
import { connect } from "react-redux";
import authSelector from "../../selectors/authSelector";
import ComposeMessage from "./ComposeMessage";
import ManagerBroadcast from "../manager/ManagerBroadcast";

class ComposeContainer extends Component {
  render() {
    const { userType } = this.props;
    if (userType === "MANAGER") {
      return <ManagerBroadcast />;
    } else {
      return <ComposeMessage />;
    }
  }
}

export default connect(authSelector)(ComposeContainer);



// WEBPACK FOOTER //
// ./src/components/common/ComposeContainer.js